import Phaser from 'phaser'
import TextureKeys from '../consts/TextureKeys'

export default class Bomb extends Phaser.Physics.Arcade.Sprite {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, TextureKeys.Bomb)

    // Add to scene
    scene.add.existing(this)
    scene.physics.add.existing(this)

    // Set up physics
    const body = this.body as Phaser.Physics.Arcade.Body
    body.setGravityY(600) // Make it fall
    body.setVelocityX(100) // Move slightly forward

    // Set smaller collision body for the bomb
    body.setCircle(this.width * 0.4)
  }

  update() {
    // Optionally add rotation as it falls for visual effect
    this.angle += 5
  }
}
